import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle2, ShoppingBag, ArrowRight, Sparkles } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useCart } from "@/contexts/CartContext";

const AddedToCartDialog = () => {
  const { lastAdded, clearLastAdded, getItemCount, getCartTotal } = useCart();
  const navigate = useNavigate();
  const location = useLocation();

  const open = !!lastAdded && location.pathname !== "/carrito" && location.pathname !== "/checkout";

  const handleClose = () => clearLastAdded();
  const handleGoToCart = () => {
    clearLastAdded();
    navigate("/carrito");
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleClose()}>
      <DialogContent className="sm:max-w-md p-0 overflow-hidden border-0 rounded-2xl">
        {/* Header gradient */}
        <div className="relative bg-gradient-to-br from-primary/10 via-background to-accent/10 px-6 pt-6 pb-4">
          <div className="absolute inset-0 opacity-30 pointer-events-none"
               style={{ background: "radial-gradient(circle at top right, hsl(var(--primary) / 0.15), transparent 60%)" }} />
          <div className="relative flex items-center gap-2 text-primary font-medium text-sm">
            <Sparkles className="h-4 w-4" />
            ¡Agregado al carrito!
          </div>
        </div>

        {lastAdded && (
          <div className="px-6 -mt-2">
            <div className="flex gap-3 items-center p-3 rounded-xl bg-muted/50 border border-border">
              <img
                src={lastAdded.image || "/images/proximamente.svg"}
                alt={lastAdded.title}
                className="w-16 h-16 rounded-lg object-cover shrink-0"
              />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5 text-xs text-green-600 font-medium mb-0.5">
                  <CheckCircle2 className="h-3.5 w-3.5" />
                  Agregado
                </div>
                <p className="font-semibold text-sm line-clamp-2">{lastAdded.title}</p>
              </div>
            </div>
          </div>
        )}

        <div className="px-6 pb-6 pt-4 space-y-3">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground flex items-center gap-1.5">
              <ShoppingBag className="h-4 w-4" />
              {getItemCount()} {getItemCount() === 1 ? "producto" : "productos"}
            </span>
            <span className="font-bold text-primary">
              ₡{getCartTotal().toLocaleString("es-CR")}
            </span>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 pt-1">
            <Button variant="outline" onClick={handleClose} className="h-11 rounded-xl">
              Seguir comprando
            </Button>
            <Button onClick={handleGoToCart} className="h-11 rounded-xl">
              Ir al carrito
              <ArrowRight className="ml-1.5 h-4 w-4" />
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AddedToCartDialog;
